exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "i[data-v-2d92dd56], .text-primary-cat2[data-v-2d92dd56] {\n  color: #801977 !important;\n}", ""]);

// exports
